module.exports = __webpack_public_path__ + "img/menulingua_logo_final.2a4fbce4.png";